module.exports = __webpack_public_path__ + "static/media/logo-no-text.4693a652.png";